import * as React from "react";
import styled from "../../../styled/index";
import { withTranslation } from "react-i18next";
const Wrapper = styled("div") `
  > div {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px dashed ${({ theme }) => theme.box.border};
    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
  }
`;
const Line = styled("div") `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: nowrap;
`;
const Left = styled("p") `
  text-align: left;
`;
const Right = styled("p") `
  text-align: right;
`;
export const RestaurantSpecialOpeningHours = withTranslation()(({ hours, t }) => {
    return (React.createElement(Wrapper, null, hours.map(({ date, opened, open, close, h24 }, i) => {
        const previousSlot = hours[i - 1] ? hours[i - 1] : null;
        const nextSlotDate = hours[i + 1] ? hours[i + 1] : null;
        let dayDisplay = t(`dateFromDate`, { value: date });
        if (previousSlot && previousSlot.date === date) {
            dayDisplay = "";
        }
        let timeDisplay = t("phrases.closed");
        if (opened) {
            if (h24) {
                timeDisplay = t("phrases.open_24");
            }
            else {
                timeDisplay = `${t("timeFromTime", { value: open })} - ${t("timeFromTime", { value: close })}`;
            }
        }
        return (React.createElement(Line, { key: i, className: nextSlotDate && nextSlotDate.date === date ? "no-border-bottom p-b-0" : "" },
            React.createElement(Left, null, dayDisplay),
            React.createElement(Right, null, timeDisplay)));
    })));
});
//# sourceMappingURL=index.js.map